<template>
    <v-menu
            v-model="menuModel"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
            max-width="350"
            @update:return-value="colorChanged"
    >
        <template v-slot:activator="{ on }">
            <v-container @click="colorPickerModel=true" class="pa-0">
                <v-row dense v-on="on">
                    <v-col class="flex-grow-1">
                        <v-btn width="100%"

                               :color="color"
                               class="mr-1"
                        >{{name}}
                        </v-btn>
                    </v-col>

                    <v-col class="flex-grow-0">
                        <v-sheet :width="36" :height="36" class="elevation-2 cursor-pointer" :color="value"></v-sheet>
                    </v-col>
                </v-row>

            </v-container>
        </template>

        <v-color-picker v-model="colorModel"
                        :width="350"
                        :swatches="swatches"
                        show-swatches
                        swatches-max-height="250"
                        @change="colorChanged"
        ></v-color-picker>
    </v-menu>
</template>

<script>

    export default {

        props: {
            value: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            color: {
                type: String,
                required: false,
                default: 'primary'
            }
        },

        computed: {
            colorModel: {
                get() {
                    return this.value;
                },
                set(color) {
                    this.lastColor = color;
                    this.$emit('input', color);
                }
            },
        },

        methods: {
            // This allows the listener to capture change even when color picker is closed
            // dialog is closed vs. input which emit colors real time as user changes colors
            colorChanged() {
                this.$emit('change', this.lastColor);
            }
        },

        data() {
            return {
                colorPickerModel: false,
                menuModel: false,
                lastColor: null,
                swatches: [
                    ['#FAFAFA', '#F5F5F5', '#EEEEEE', '#E0E0E0', '#BDBDBD', '#9E9E9E', '#757575', '#616161', '#3b3b3b'],
                    ['#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373', '#EF5350', '#E53935', '#D32F2F', '#C62828', '#B71C1C'],
                    ['#FBE9E7', '#FFCCBC', '#FFAB91', '#FF8A65', '#FF7043', '#F4511E', '#E64A19', '#D84315', '#BF360C'],
                    ['#FFFDE7', '#FFF9C4', '#FFF59D', '#FFF176', '#FFEE58', '#FDD835', '#FBC02D', '#F9A825', '#F57F17'],
                    ['#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784', '#66BB6A', '#43A047', '#388E3C', '#2E7D32', '#1B5E20'],
                    ['#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1'],
                ],
            }
        },
    }
</script>
